import React, { ReactNode } from 'react'
import SEO from '../global/SEO'
import CustomerCareButton from './CustomerCareButton'
import Footer from './Footer'
import Header from './Header'
import ScrollToTop from './ScrollToTop'
import EmailContactToast from 'components/Layout/EmailContactToast'

interface Props {
	/**
	 * The name of the page that matches a PageSEO entry in Contentful
	 */
	pageName?: string
	/**
	 * If there is a subNav component being use on the page, it will hide the shadow
	 */
	subNav?: boolean
	/**
	 * If set to `false`, will hide the header
	 *
	 * Is set to `true` by default
	 */
	showHeader?: boolean
	/**
	 * If set to `false`, will hide the footer
	 *
	 * Is set to `true` by default
	 */
	showFooter?: boolean
	/**
	 * If set to `true`, will have the dots background
	 *
	 * Is set to `false` by default
	 */
	dots?: boolean
	children: ReactNode
}

const Layout = ({ pageName, subNav, showHeader = true, showFooter = true, dots, children }: Props) => {
	return (
		<div id="top" className="flex min-h-screen flex-col bg-white">
			{/* <div className="w-full bg-black">
				<span className="inline-block w-full px-4 py-2 text-center text-white">
					Please be aware that American Reading Company will be closed July 1st through July 9th, and will reopen July 10th.
				</span>
			</div> */}
			{showHeader && <Header subNav={subNav} />}

			<main className="relative flex-1">
				{dots && <div className="absolute inset-0 h-full w-full bg-white bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px]" />}
				{children}
			</main>
			{pageName && <SEO pageName={pageName} />}
			{showFooter && <Footer />}
			<ScrollToTop />
			<CustomerCareButton />
			<EmailContactToast />
		</div>
	)
}

export default Layout
